module.exports = __webpack_public_path__ + "img/rheuminfo.6d997d19.png";